import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { pairwise, startWith, take, tap } from "rxjs/operators";
import { ExtendedMediaStream } from "youm-lib";

@Injectable()
export class AccountCamMicStreamService implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private readonly _stream$ = new BehaviorSubject<null | ExtendedMediaStream>(
    null
  );
  private readonly _streams$ = this._stream$.pipe(startWith(null), pairwise());

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    this._streams$
      .pipe(
        take(1),
        tap((_) => _[0]?.destroy()),
        tap((_) => _[1]?.destroy())
      )
      .subscribe();

    this._stream$.complete();
  }

  get stream() {
    return this._stream$.value;
  }

  get stream$() {
    return this._stream$.asObservable();
  }

  get streams$() {
    return this._streams$;
  }

  set(stream: ExtendedMediaStream) {
    this._stream$.next(stream);
  }

  release() {
    const stream = this._stream$.value;
    if (!stream) {
      return;
    }

    stream.destroy();

    this._stream$.next(null);
  }
}
